

const restartPause = 2000;

const unquoteCredential = (v) => (
    JSON.parse(`"${v}"`)
);

const linkToIceServers = (links) => (
    (links !== null) ? links.split(', ').map((link) => {
        const m = link.match(/^<(.+?)>; rel="ice-server"(; username="(.*?)"; credential="(.*?)"; credential-type="password")?/i);
        const ret = {
            urls: [m[1]],
        };

        if (m[3] !== undefined) {
            ret.username = unquoteCredential(m[3]);
            ret.credential = unquoteCredential(m[4]);
            ret.credentialType = "password";
        }

        return ret;
    }) : []
);

const parseOffer = (offer) => {
    const ret = {
        iceUfrag: '',
        icePwd: '',
        medias: [],
    };

    for (const line of offer.split('\r\n')) {
        if (line.startsWith('m=')) {
            ret.medias.push(line.slice('m='.length));
        } else if (ret.iceUfrag === '' && line.startsWith('a=ice-ufrag:')) {
            ret.iceUfrag = line.slice('a=ice-ufrag:'.length);
        } else if (ret.icePwd === '' && line.startsWith('a=ice-pwd:')) {
            ret.icePwd = line.slice('a=ice-pwd:'.length);
        }
    }

    return ret;
};

const generateSdpFragment = (offerData, candidates) => {
    const candidatesByMedia = {};
    for (const candidate of candidates) {
        const mid = candidate.sdpMLineIndex;
        if (candidatesByMedia[mid] === undefined) {
            candidatesByMedia[mid] = [];
        }
        candidatesByMedia[mid].push(candidate);
    }

    let frag = 'a=ice-ufrag:' + offerData.iceUfrag + '\r\n'
        + 'a=ice-pwd:' + offerData.icePwd + '\r\n';

    let mid = 0;

    for (const media of offerData.medias) {
        if (candidatesByMedia[mid] !== undefined) {
            frag += 'm=' + media + '\r\n'
                + 'a=mid:' + mid + '\r\n';

            for (const candidate of candidatesByMedia[mid]) {
                frag += 'a=' + candidate.candidate + '\r\n';
            }
        }
        mid++;
    }

    return frag;
}

class WHEPClient {
    constructor(url, { videoElement, onStatusChange } = {}) {
        this.dynamicUrl=url
        this.videoElement = videoElement || null;
        this.onStatusChange = onStatusChange;
        this.pc = null;
        this.restartTimeout = null;
        this.eTag = '';
        this.queuedCandidates = [];
        this.disposed = false;
        this.start();
    }

    setStatus(status) {
        this.onStatusChange?.(status);
    }

    start() {
        if (this.disposed) return;

        this.setStatus("Connecting");
        // fetch(new URL('whep', "http://192.168.10.123:8889/nuc_cam/"), {
            // fetch(new URL('whep', "http://192.168.10.123:8889/nuc_cam"), {
        fetch(new URL('whep', `${this.dynamicUrl}`), {
            method: 'OPTIONS',
        })
            .then((res) => this.onIceServers(res))
            .catch((err) => {
                if (this.disposed) return;
                console.log('error: ' + err);
                this.setStatus("Connection failed");
                this.scheduleRestart();
            });
    }

    onIceServers(res) {
        if (this.disposed) return;

        this.pc = new RTCPeerConnection({
            iceServers: linkToIceServers(res.headers.get('Link')),
        });

        const direction = "sendrecv";
        this.pc.addTransceiver("video", { direction });
        this.pc.addTransceiver("audio", { direction });

        // this.pc.onicecandidate = (evt) => this.onLocalCandidate(evt);
        this.pc.oniceconnectionstatechange = () => this.onConnectionState();
        this.pc.onconnectionstatechange = () => this.onConnectionState();

        this.pc.ontrack = (evt) => {
            if (this.disposed) return;
            const video = this.videoElement || document.getElementById("video");
            if (video) video.srcObject = evt.streams[0];
            this.setStatus("Connected");
        };

        this.pc.createOffer()
            .then((offer) => this.onLocalOffer(offer));
    }

    onLocalOffer(offer) {
        if (this.disposed || !this.pc) return;

        this.offerData = parseOffer(offer.sdp);
        this.pc.setLocalDescription(offer);

        console.log("sending offer");

        //fetch(new URL('whep', "http://192.168.10.18:8889/mystream/"), {
            // fetch(new URL('whep', "http://192.168.10.123:8889/nuc_cam/"), {
                fetch(new URL('whep', `${this.dynamicUrl}`), {
            method: 'POST',
            headers: {
                'Content-Type': 'application/sdp',
            },
            body: offer.sdp,
        })
            .then((res) => {
                if (this.disposed) return null;
                if (res.status !== 201) {
                    throw new Error('bad status code');
                }
                this.eTag = res.headers.get('ETag');
                return res.text();
            })
            .then((sdp) => {
                if (!sdp || this.disposed) return;
                this.onRemoteAnswer(new RTCSessionDescription({
                    type: 'answer',
                    sdp,
                }));
            })
            .catch((err) => {
                if (this.disposed) return;
                console.log('error: ' + err);
                this.setStatus("Connection failed");
                this.scheduleRestart();
            });
    }

    onConnectionState() {
        if (this.restartTimeout !== null) {
            return;
        }

        if (!this.pc || this.disposed) return;

        const connectionState = this.pc.connectionState || this.pc.iceConnectionState;

        switch (connectionState) {
        case "connected":
            this.setStatus("Connected");
            break;
        case "failed":
        case "disconnected":
            this.setStatus("Reconnecting");
            this.scheduleRestart();
            break;
        }
    }

	onRemoteAnswer(answer) {
        if (this.disposed || this.restartTimeout !== null || !this.pc) {
            return;
        }

		this.pc.setRemoteDescription(new RTCSessionDescription(answer));

        if (this.queuedCandidates.length !== 0) {
            this.sendLocalCandidates(this.queuedCandidates);
            this.queuedCandidates = [];
        }
	}

    onLocalCandidate(evt) {
        if (this.restartTimeout !== null) {
            return;
        }

        if (evt.candidate !== null) {
            if (this.eTag === '') {
                this.queuedCandidates.push(evt.candidate);
            } else {
                this.sendLocalCandidates([evt.candidate])
            }
        }
    }

    // sendLocalCandidates(candidates) {
    //     fetch(new URL('whep', "http://192.168.10.18:8889/mystream/") , {
    //         method: 'PATCH',
    //         headers: {
    //             'Content-Type': 'application/trickle-ice-sdpfrag',
    //             'If-Match': this.eTag,
    //         },
    //         body: generateSdpFragment(this.offerData, candidates),
    //     })
    //         .then((res) => {
    //             if (res.status !== 204) {
    //                 throw new Error('bad status code');
    //             }
    //         })
    //         .catch((err) => {
    //             console.log('error: ' + err);
    //             this.scheduleRestart();
    //         });
    // }

    scheduleRestart() {
        if (this.disposed || this.restartTimeout !== null) {
            return;
        }

        if (this.pc !== null) {
            this.pc.close();
            this.pc = null;
        }

        this.restartTimeout = window.setTimeout(() => {
            if (this.disposed) return;
            this.restartTimeout = null;
            this.start();
        }, restartPause);

        this.eTag = '';
        this.queuedCandidates = [];
    }

    stop() {
        this.disposed = true;

        if (this.restartTimeout !== null) {
            window.clearTimeout(this.restartTimeout);
            this.restartTimeout = null;
        }

        if (this.pc !== null) {
            this.pc.close();
            this.pc = null;
        }

        if (this.videoElement?.srcObject) {
            this.videoElement.srcObject.getTracks?.().forEach((track) => track.stop());
            this.videoElement.srcObject = null;
        }

        this.setStatus("Disconnected");
    }
}

 //export default function webrtcLoad() { new WHEPClient()};
 export default function webrtcLoad(url, options) {
    const client = new WHEPClient(url, options);
    return () => client.stop();
 };
